import styled from "styled-components";
const BasicButton = styled.button`
  all: unset;
  cursor: pointer;
  background-color: var(--color-amber-400);
  border-radius: 8px;
  padding: 24px 16px;
  font-family: monospace;
  font-size: 1.5rem;
  @media (min-width: 600px) {
    font-size: 2rem;
  }

  font-weight: bold;
  color: var(--color-indigo-900);
  border: 1px solid var(--color-indigo-900);

  transition:
    opacity 0.25s ease-in-out,
    background-color 0.25s ease-in-out;

  opacity: var(--opacity);
  pointer-events: var(--pointer-events);

  @media (hover: hover) {
    &:hover {
      background-color: var(--color-amber-500);
    }
  }
  text-align: center;
`;
export default BasicButton;
